<template>
  <div>
    <a v-if="destinations.length && showMoreLink" href="#" @click="toggleActive" :class="isActive ? 'toggle-listing active' : 'toggle-listing'">
      {{ isActive ? $t('hideinformations') : $t('showinformations') }}
    </a>
    <div :class="listingClasses">

      <div v-if="destinations.length" class="pthvSchedule-list">

        <div class="time-infos indicateurs-wrapper">
          <span class="real-time-info indicateurs" :title="$t('realTime')">
            <i class="icon-infos realTime"></i>
            {{ $t('realTime') }}
          </span>
          <span class="theorical-time-info indicateurs" :title="$t('scheduledService')">
            <i class="icon-infos approx"></i>
            {{ $t('scheduledService') }}
          </span>
        </div>

        <div class="stopAreaDirection-wrapper">
          <div v-if="!allDirections" id="thStopareasDirection" class="stopAreaDirection">
            <div class="schedule-direction schedule-listing-head">
              <span class="schedule-direction-name griditem-1">{{ destinationFrom }}</span>
              <div class="griditem-2">
                <directionArrowSVG></directionArrowSVG>
              </div>
              <span class="schedule-direction-name griditem-3">{{ destinationTo }}</span>
            </div>
          </div>
          <button v-if="hasBothDirections" type="button" :title="$t('changedirection')" @click="switchDirection" class="btn-change-direction">
            {{ $t("changedirection") }}
            <changeDirectionSVG></changeDirectionSVG>
          </button>
        </div>

        <div class="pthvSchedule-listHead-tr hidden" v-if="destinationsByDir.length > 0 && showTableHeader">
          <div class="pthvSchedule-line-head">
            <span class="pthvSchedule-modeLine-head">
              {{ $t("line") }}
            </span>
            <span>
              {{ $t("destination") }}
            </span>
          </div>
          <div class="pthvSchedule-nextDeparture-head">
            {{ $t("nextTrips") }}
          </div>
          <div class="apthSchedule-occupancy-head" v-if="hasOccupancyData">
            {{ $t("occupancy") }}
          </div>
        </div>

        <div class="pthvSchedule-listHead" v-if="destinationsByDir.length > 1 && showTableHeader">
          {{ $t("line") }} / {{ $t("destination") }} / {{ $t("nextTrips") }} {{ hasOccupancyData ? '/' + $t("occupancy") : '' }}
        </div>

        <div v-if="horizontalSchedules">
          <ApthScheduleStopDestination
            v-for="(destination, index) in destinationsByDir"
            :key="index"
            :destination="destination"
            :showOccupancy="showOccupancy"
            :showDeparture="showDeparture"
            :showTerminus="showTerminus"
            :alwaysShowHours="alwaysShowHours"
            :indicators="indicators"
            @click="onLineClick(destination)"
          />
        </div>
        <div v-else>
          <ApthScheduleStopDestinationVertical
            v-for="(destination, index) in destinationsByDir"
            :key="index"
            :destination="destination"
            :showOccupancy="showOccupancy"
            :showDeparture="showDeparture"
            :showTerminus="showTerminus"
            :alwaysShowHours="alwaysShowHours"
            :indicators="indicators"
            @click="onLineClick(destination)"
          />
        </div>
      </div>
      <div v-else class="pthvSchedule-nolist">

        <span> {{ $t("notFound") }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import ApthScheduleStopDestination from "./ApthScheduleStopDestination";
import ApthScheduleStopDestinationVertical from "./ApthScheduleStopDestinationVertical";

// Other components
import directionArrowSVG from "./svg/directionArrowSVG";
import changeDirectionSVG from "./svg/changeDirectionSVG";

export default {
  name: "ApthScheduleListing",
  data() {
    return {
      directionSwitched: false,
      isActive: true,
    };
  },
  components: {
    ApthScheduleStopDestination,
    ApthScheduleStopDestinationVertical,
    directionArrowSVG,
    changeDirectionSVG,
  },
  props: {
    destinations: {
      type: Array,
      required: true
    },
    allDirections: {
      type: Boolean,
      required: false,
      default: false
    },
    allLines: {
      type: Boolean,
      required: false,
      default: true,
    },
    showOccupancy: {
      type: Boolean,
      required: false,
      default: true,
    },
    showDeparture: {
      type: Boolean,
      required: false,
      default: true,
    },
    showTerminus: {
      type: Boolean,
      required: false,
      default: true,
    },
    horizontalSchedules: {
      type: Boolean,
      required: false,
      default: true,
    },
    alwaysShowHours: {
      type: Boolean,
      required: false,
      default: false,
    },
    indicators: {
      type: Object,
      required: false,
      default: () => {
        return {
          'any': true,
        };
      },
    },
    showTableHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
    showMoreLink: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  computed: {
    listingClasses() {
      let listingClasses = this.isActive ? 'pthvSchedule-listing' : 'pthvSchedule-listing hidden';
      listingClasses += this.hasOccupancyData ? ' with-occupancy' : '';
      return listingClasses;
    },
    directionIni(){
      let dests0 = this.destinations.filter((dest) => {
        return dest.direction == 0;
      });
      return dests0.length > 0 ? 0 : 1;
    },
    direction(){
      let direction = this.directionIni;
      if (this.directionSwitched){
        direction = direction == 0 ? 1 : 0;
      }
      return direction;
    },
    hasBothDirections() {
      if (this.allDirections){
        return false;
      }
      let dests0 = this.destinations.filter((dest) => {
        return dest.direction == 0;
      });
      return this.destinations.length > dests0.length && dests0.length > 0;
    },
    destinationsByDir() {
      if (this.allDirections){
        return this.destinations;
      }
      let dir = this.direction;
      return this.destinations.filter((dest) => {
        return dest.direction == dir;
        // return dest.direction == this.direction;
      });
    },
    hasOccupancyData() {
      if (!this.showOccupancy) {
        return false;
      }
      let hasOccupancyData = false;
      this.destinationsByDir.filter(function(dest) {
        dest.times.filter(function(time){
          if (time.hasOwnProperty('occupancy')) {
            hasOccupancyData = true;
          }
        });
      });
      return hasOccupancyData;
    },
    to() {
      // infos de la ligne si récupérées
      if (this.destinations.length > 0){
        let dest = this.destinations[0];
        if ('line' in dest && 'infos' in dest.line && 'dir0_label' in dest.line.infos){
          return dest.line.infos.dir0_label;
        }
      }

      let dir0 = this.destinations.filter((dest) => {
        return dest.direction == 0;
      });
      if (dir0.length > 0){
        let txt = dir0[0].dirlib;
        return txt.replace(/\//g, " / "); // ajout d'espaces autour du séparateur de directions '/'
      }
      // la direction dir0 n'est pas disponible, on utilise le libellé from de la direction inverse
      let dir1 = this.destinations.filter((dest) => dest.direction == 1);
      if (dir1.length > 0){
        let txt = dir1[0].fromlib;
        return txt.replace(/\//g, " / "); // ajout d'espaces autour du séparateur de directions '/'
      }
      return "";
    },
    from() {
      // infos de la ligne si récupérées
      if (this.destinations.length > 0){
        let dest = this.destinations[0];
        if ('line' in dest && 'infos' in dest.line && 'dir1_label' in dest.line.infos){
          return dest.line.infos.dir1_label;
        }
      }

      let dir1 = this.destinations.filter((dest) => {
        return dest.direction == 1;
      });
      if (dir1.length > 0){
        let txt = dir1[0].dirlib;
        return txt.replace(/\//g, " / ");
      }
      // la direction dir1 n'est pas disponible, on utilise le libellé from de la direction inverse
      let dir0 = this.destinations.filter((dest) => {
        return dest.direction == 0;
      });
      if (dir0.length > 0){
        let txt = dir0[0].fromlib;
        return txt.replace(/\//g, " / "); // ajout d'espaces autour du séparateur de directions '/'
      }
      return "";
    },
    destinationFrom() {
      return this.direction == 0 ? this.from : this.to;
    },
    destinationTo() {
      return this.direction == 0 ? this.to : this.from;
    }
  },
  methods: {
    onLineClick(destination) {
      this.$emit("stopSelected", destination);
    },
    switchDirection: function() {
      this.directionSwitched = !this.directionSwitched;
    },
    toggleActive: function(event) {
      this.isActive = !this.isActive;
      event.preventDefault();
    },
  }
};
</script>

<style lang="scss">
@import "../styles/utilities/_variables.scss";

.indicateurs-wrapper,
.hidden {
  display: none;
}

.toggle-listing {
  display: none;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  column-gap: 0.5rem;
  margin-block: 1rem;

  &:after {
    display: block;
    content: "\25bE";
  }
  &.active {
    &:after {
      content: "\25B4";
    }
  }
}

.schedule-listing-head,
.schedule-listing-row {
  display: grid;
}

.schedule-listing-row {
  grid-template-columns: 1fr 1fr 1fr;
}
.schedule-listing-head {
  grid-template-columns: 1fr 4rem 1fr;

  .griditem-1,
  .griditem-2,
  .griditem-3 {
    justify-self: center;
  }
}
.stopAreaDirection {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f2f2f2;
  min-height: 140px;

  &-wrapper {
    position: relative;
  }

  > button {
    cursor: pointer;
    position: absolute;
    bottom: 0;
    right: 50%;
    transform: translate(50%) translateY(-50%);
  }
}
.btn-change-direction {
  position: absolute;
  left: 50%;
  bottom: 8px;
  font-size: 0;
  padding: 10px;
  border: none;
  border-radius: 50%;
  background: #FFF;
  cursor: pointer;
  transform: translate(-50%, 0);
}
.schedule-direction {
  width: 100%;
  align-items: center;

  &-name {
    font-weight: bold;
    padding: 16px;
    text-align: center;
  }
}
.pthvSchedule-listing {
  padding: 0.25rem;
}
.pthvSchedule-listHead {
  padding: 0.25rem;
  font-family: $apth_fontFamily;
}
.pthvSchedule-nolist {
  padding: 0.25rem;
}
</style>
